export default __webpack_public_path__ + "static/media/banner101.f4cdb76e.jpg";